<template>
  <div class="cr-panel batch-guides-tab">
    <div class="cr-table-scroll">
      <table class="table table-hover">
        <thead>
        <tr>
          <th class="seq">Seq</th>
          <th>Guia</th>
          <th>Paciente</th>
          <th class="hide-sm">Profissional</th>
          <th>Data</th>
          <th class="text-right hide-sm">Itens</th>
          <th class="text-right">Faturado</th>
          <template v-if="analyzed">
            <th class="text-right">Glosado</th>
            <th class="text-right">Liberado</th>
            <th class="text-right hide-sm">Recursado</th>
            <th>Situação</th>
          </template>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(guide, index) in guides" :key="guide.id">
          <td class="num seq">{{ index + 1 }}</td>
          <td>
            <span class="text-bold num">{{ guideNumber(guide) || '—' }}</span>
            <span class="sub">{{ operatorLabel(guide) }}</span>
          </td>
          <td>
            <span class="text-bold">{{ guide.patient ? guide.patient.name : '—' }}</span>
            <span class="sub" v-if="guide.insurance && guide.insurance.insured">
              {{ guide.insurance.insured.record || 'Sem carteirinha' }}
            </span>
          </td>
          <td class="hide-sm">{{ guide.professional ? guide.professional.name : '—' }}</td>
          <td class="num">{{ guide.startDate | date }}</td>
          <td class="text-right hide-sm">{{ guide.itemsCount }}</td>
          <td class="text-right num text-bold">{{ totalsOf(guide).informed | currency }}</td>
          <template v-if="analyzed">
            <td class="text-right num" :class="{'text-error': guideValue(guide, 'glossed') > 0}">
              {{ guideValue(guide, 'glossed') | currency }}
            </td>
            <td class="text-right num">{{ guideValue(guide, 'released') | currency }}</td>
            <td class="text-right num hide-sm">{{ guideValue(guide, 'appealed') | currency }}</td>
            <td>
              <span class="guide-status" :class="`guide-status-${guide.analysisStatus}`">
                {{ analysisStatusName(guide.analysisStatus) }}
              </span>
            </td>
          </template>
          <td class="actions-cell">
            <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                    data-tooltip="Abrir guia" @click="$emit('open', guide.id)">
              <fa-icon :icon="['fal', 'eye']"/>
            </button>
            <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                    data-tooltip="Imprimir guia"
                    :class="{loading: printingId === guide.id}" :disabled="!!printingId"
                    @click="$emit('print', guide.id)">
              <fa-icon :icon="['fal', 'print']"/>
            </button>
            <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                    :data-tooltip="removeDisabled || 'Retirar do lote'"
                    :class="{loading: removingId === guide.id}"
                    :disabled="!!removeDisabled || !!removingId"
                    @click="$emit('remove', guide)">
              <fa-icon :icon="['fal', 'minus-circle']"/>
            </button>
          </td>
        </tr>
        <tr class="add-row" v-if="canAdd">
          <td :colspan="columnCount">
            <button class="btn btn-primary btn-sm btn-icon btn-icon-left" @click="$emit('add')">
              <fa-icon :icon="['fal', 'plus']"/>Adicionar guias
            </button>
            <span class="add-row-hint">Só guias abertas do mesmo plano e tipo</span>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th colspan="6" class="text-right">Totais</th>
          <th class="text-right num">{{ totals.informed | currency }}</th>
          <template v-if="analyzed">
            <th class="text-right num" :class="{'text-error': totals.glossed > 0}">
              {{ totals.glossed | currency }}
            </th>
            <th class="text-right num">{{ totals.released | currency }}</th>
            <th class="text-right num hide-sm">{{ totals.appealed | currency }}</th>
            <th colspan="2"></th>
          </template>
          <th v-else></th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { guideNumber, analysisStatusName, sumBy } from '../service';

const ANALYZED = ['analyzed', 'in_appeal', 'settled'];

export default {
  props: {
    batch: {
      type: Object,
      required: true,
    },
    guides: {
      type: Array,
      default: () => [],
    },
    canAdd: {
      type: Boolean,
      default: false,
    },
    removeDisabled: {
      type: String,
      default: null,
    },
    printingId: {
      type: String,
      default: null,
    },
    removingId: {
      type: String,
      default: null,
    },
  },
  computed: {
    analyzed() {
      return ANALYZED.includes(this.batch.status);
    },
    columnCount() {
      return this.analyzed ? 12 : 8;
    },
    totals() {
      return {
        informed: sumBy(this.guides, guide => this.totalsOf(guide).informed),
        glossed: sumBy(this.guides, guide => this.totalsOf(guide).glossed),
        released: sumBy(this.guides, guide => this.totalsOf(guide).released),
        appealed: sumBy(this.guides, guide => this.totalsOf(guide).appealed),
      };
    },
  },
  methods: {
    guideNumber,
    analysisStatusName,
    totalsOf(guide) {
      return guide.totals || {};
    },
    guideValue(guide, field) {
      return this.totalsOf(guide)[field] || 0;
    },
    operatorLabel(guide) {
      const operator = guide.referral && guide.referral.insurance;
      const password = guide.authorization && guide.authorization.password;
      return [
        operator ? `Op. ${operator}` : null,
        password ? `senha ${password}` : null,
      ].filter(Boolean).join(' · ') || 'Sem nº da operadora';
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.batch-guides-tab {
  .table {
    th.seq {
      width: 2rem;
    }
    td.seq {
      color: $gray-color-dark;
      font-weight: 600;
    }
  }
}
</style>
